<template>
	<div class="searchPart">
		<!-- 姓名注册时间 -->
		<el-row :gutter="40" class='select_row'>
		  	<el-col :span="7">
		  		<el-row>
		  			<el-col :span='16' class='floatR'>
		  				<el-input placeholder="请输入内容" size='small'
		  				v-model.trim="selectVal.content.val"
						class="input-with-select">
						</el-input>
		  			</el-col>
		  			<el-col :span='8'>
						<el-select v-model="selectVal.content.key"
						 placeholder="请选择" size='small'
						 class='floatR' style="max-width: 100px;">
						    <el-option
						      v-for="item in select.content"
						      :key="item.id"
						      :label="item.name"
						      :value="item.id">
						    </el-option>
					  	</el-select>
		  			</el-col>
		  		</el-row>
	  		</el-col>
		  	<el-col :span="7">
		  		<el-row>
		  			<el-col :span='16' class='floatR'>
					  	<datetime-range ref='datetime' :defaultTime='timeRange'>
					  	</datetime-range>
		  			</el-col>
		  			<el-col :span='8'>
		  				<el-select v-model="selectVal.timeType" placeholder="请选择"
		  				 size='small' class='floatR' style="max-width: 130px;"> 
						    <el-option
						      v-for="item in select.time"
						      :key="item.id"
						      :label="item.name"
						      :value="item.id">
						    </el-option>
					  	</el-select>
		  			</el-col>
		  		</el-row>
		  	</el-col>
		</el-row>
		<!-- 职称科室 -->
		<el-row :gutter="40" class='select_row'>
		  	<el-col :span="7">
		  		<el-row>
		  			<el-col :span='8' class="select_span">
		  				<span>选择职称:</span>
		  			</el-col>
		  			<el-col :span='14'>
		  				<el-select v-model="selectVal.jobTitleSelect" placeholder="请选择" size='small'>
						    <el-option
						      v-for="item in select.jobTitleSelect"
						      :key="item.id"
						      :label="item.name"
						      :value="item.id">
						    </el-option>
					  	</el-select>
		  			</el-col>
		  		</el-row>
		  	</el-col>
		  	<el-col :span="7">
		  		<el-row>
		  			<el-col :span='8' class="select_span">
		  				<span>选择科室:</span>
		  			</el-col>
		  			<el-col :span='14'>
						<el-cascader
							v-model="selectVal.departmentsSelect"
							:options="select.departmentsSelect"
							:props="{
								emitPath: false,
								label: 'name',
								value: 'id'
							}"
							size="small"
							ref="cascader"
						></el-cascader>
		  			</el-col>
		  		</el-row>
		  	</el-col>
		</el-row>
		<!-- 审核方式注册来源 -->
		<el-row :gutter="40" class='select_row'>
		  	<el-col :span="7" v-if='select.auditingTypeSelect!=-1'>
		  		<el-row>
		  			<el-col :span='8' class="select_span">
		  				<span>审核方式:</span>
		  			</el-col>
		  			<el-col :span='14'>
		  				<el-select v-model="selectVal.auditingTypeSelect" placeholder="请选择" size='small'>
						    <el-option
						      v-for="item in select.auditingTypeSelect"
						      :key="item.id"
						      :label="item.name"
						      :value="item.id">
						    </el-option>
					  	</el-select>
		  			</el-col>
		  		</el-row>
		  	</el-col>
		  	<el-col :span="7">
		  		<el-row>
		  			<el-col :span='8' class="select_span">
				  	  	<span>注册来源:</span>
		  			</el-col>
		  			<el-col :span='14'>
		  				<el-select v-model="selectVal.sourceSelect" placeholder="请选择" size='small'>
						    <el-option
						      v-for="item in select.sourceSelect"
						      :key="item.id"
						      :label="item.name"
						      :value="item.id">
						    </el-option>
					  	</el-select>
		  			</el-col>
		  		</el-row>
		  	</el-col>
		  	<el-col :span="7" v-if="select.addAuthSelect">
				<el-row>
					<el-col :span='8' class="select_span">
						<span>认证类型:</span>
		  			</el-col>
		  			<el-col :span='14'>
						<el-cascader 
							v-model="selectVal.authType"
							:options="authType" size="small"
							:props="{ expandTrigger: 'hover', emitPath: false }"
							@change="authTypeChange">
						</el-cascader>
		  			</el-col>
				</el-row>
			</el-col>
		</el-row>
		<!-- 地区 -->
		<el-row :gutter="40" class='select_row'
			v-if='select.province!=-1'>
			<el-col :span="14">
				<el-row>
		  			<el-col :span='4' class="select_span">
		  				<span>地区医院:</span>
		  			</el-col>
				  	<el-col :span="20">
						<el-select v-model="selectVal.province"
						 placeholder="请选择" size='small' @change='provinceChange'>
						    <el-option
						      v-for="item in select.province"
						      :key="item.code"
						      :label="item.name"
						      :value="item.code">
						    </el-option>
					  	</el-select>
						<el-select v-model="selectVal.city" placeholder="请选择" size='small' @change='cityChange'>
						    <el-option
						      v-for="item in select.city"
						      :key="item.code"
						      :label="item.name"
						      :value="item.code">
						    </el-option>
					  	</el-select>
						<el-select v-model="selectVal.hospital" placeholder="请选择" size='small'
						 v-if="select.hospital!=-1">
						    <el-option
						      v-for="item in select.hospital"
						      :key="item.id"
						      :label="item.hospitalname"
						      :value="item.id">
						    </el-option>
					  	</el-select>
				  	</el-col>
		  		</el-row>
			</el-col>
		</el-row>
		<!-- 终端&来源名称 -->
		<el-row :gutter="40" class='select_row' v-if="select.identify===0">
		  	<el-col :span="7">
				<el-row>
					<el-col :span='8' class="select_span">
						<span>来源终端:</span>
					</el-col>
					<el-col :span='14'>
						<el-select v-model="selectVal.clientType" placeholder="请选择" size='small'>
							<el-option
							v-for="item in clientType"
							:key="item.id"
							:label="item.name"
							:value="item.id">
							</el-option>
						</el-select>
					</el-col>
				</el-row>
			</el-col>
			<el-col :span="7">
				<el-row>
					<el-col :span="16" class="floatR">
						<el-input placeholder="请输入内容" size="small" v-model.trim="selectVal.sourceNameKey"
							class="input-with-select">
						</el-input>
					</el-col>
					<el-col :span="8" class="select_span">
						<span>来源名称:</span>
					</el-col>
				</el-row>
			</el-col>
		</el-row>
		<!-- 身份 -->
		<el-row :gutter="40" class='select_row' v-if="select.identify===0 || select.identify===1">
		  	<el-col :span="7">
		  		<el-row>
		  			<el-col :span='8' class="select_span">
				  	  	<span>身份:</span>
		  			</el-col>
		  			<el-col :span='14'>
		  				<el-select v-model="selectVal.type" placeholder="请选择" size='small'>
						    <el-option
						      v-for="item in identifyList"
						      :key="item.id"
						      :label="item.name"
						      :value="item.id">
						    </el-option>
					  	</el-select>
		  			</el-col>
		  		</el-row>
		  	</el-col>
		  	<el-col :span="7">
		  		<el-row>
		  			<el-col :span='8' class="select_span">
				  	  	<span>是否讲师:</span>
		  			</el-col>
		  			<el-col :span='14'>
		  				<el-select v-model="selectVal.isTeacher" placeholder="请选择" size='small'>
						    <el-option :label="'全部'" :value="''"></el-option>
						    <el-option :label="'是'" :value="true"></el-option>
						    <el-option :label="'否'" :value="false"></el-option>
					  	</el-select>
		  			</el-col>
		  		</el-row>
		  	</el-col>
			<el-col :span="7">
		  		<el-row v-if="select.addAuthSelect">
		  			<el-col :span='8' class="select_span">
				  	  	<span>是否首次认证:</span>
		  			</el-col>
		  			<el-col :span='14'>
		  				<el-select v-model="selectVal.firstAuth" placeholder="请选择" size='small'>
						    <el-option
						      v-for="(item, index) in firstAuth"
							  :key="index"
						      :label="item.label"
						      :value="item.value">
						    </el-option>
					  	</el-select>
		  			</el-col>
		  		</el-row>
		  	</el-col>
		</el-row>
		<!-- 学科&APP推送 -->		
		<el-row :gutter="40" class='select_row' v-if="select.disciplineList">
		  	<el-col :span="7">
		  		<el-row>
		  			<el-col :span='8' class="select_span">
				  	  	<span>主学科:</span>
		  			</el-col>
		  			<el-col :span='14'>
		  				<el-select v-model="selectVal.disciplineId" placeholder="请选择" size='small'>
						    <el-option
						      v-for="item in disciplineList"
						      :key="item.id"
						      :label="item.name"
						      :value="item.id">
						    </el-option>
					  	</el-select>
		  			</el-col>
		  		</el-row>
		  	</el-col>
			<el-col :span="7">
		  		<el-row>
		  			<el-col :span='8' class="select_span">
				  	  	<span>APP推送:</span>
		  			</el-col>
		  			<el-col :span='14'>
		  				<el-select v-model="selectVal.isOpenAppPush" placeholder="请选择" size='small'>
						    <el-option
						      v-for="item in isOpenAppPushList"
						      :key="item.id"
						      :label="item.name"
						      :value="item.id">
						    </el-option>
					  	</el-select>
		  			</el-col>
		  		</el-row>
		  	</el-col>
		</el-row>
		<!-- 微信绑定 -->
		<el-row :gutter="40" class='select_row' v-if="select.disciplineList">
			<el-col :span="7">
		  		<el-row>
		  			<el-col :span='8' class="select_span">
				  	  	<span>微信绑定:</span>
		  			</el-col>
		  			<el-col :span='14'>
		  				<el-select v-model="selectVal.isBindWechat" placeholder="请选择" size='small'>
						    <el-option
						      v-for="item in isBindWechatList"
						      :key="item.id"
						      :label="item.name"
						      :value="item.id">
						    </el-option>
					  	</el-select>
		  			</el-col>
		  		</el-row>
		  	</el-col>
		</el-row>
		<!-- 认证状态 -->
		<el-row :gutter='40' class='select_row'>
			<el-col :span="14" v-if='select.checkList'>
		  		<el-row>
		  			<el-col :span='4' class="select_span">
		  				<span>认证状态:</span>
		  			</el-col>
		  			<el-col :span='20'>
		  				<el-checkbox-group v-model="selectVal.checkList" class='check_group'>
						    <el-checkbox v-for='item in select.checkList'
						     :label='item.id' :key='item.id'>{{item.name}}</el-checkbox>
					  	</el-checkbox-group>
		  			</el-col>
		  		</el-row>
			</el-col>
			<el-col :span="7">
		  		<el-row v-if="select.addAuthSelect">
		  			<el-col :span='8' class="select_span">
				  	  	<span>是否审核:</span>
		  			</el-col>
		  			<el-col :span='14'>
		  				<el-select v-model="selectVal.audit" placeholder="请选择" size='small'>
						    <el-option
						      v-for="(item, index) in auditList"
							  :key="index"
						      :label="item.label"
						      :value="item.value">
						    </el-option>
					  	</el-select>
		  			</el-col>
		  		</el-row>
		  	</el-col>
		</el-row>
	</div>
</template>

<script scoped>
	import datetimeRange from '@/components/datetimeRange'
	import subjectApi from '@/api/contentManage/courseSubject'
	import commonApi from '@/api/common'

	export default {
		name: 'searchPart',
		components: {
			datetimeRange
		},
		data() {
			return {
				timeRange: [
					this.$moment().add(-1, 'years')
						.format('YYYY-MM-DD HH:mm:ss'),
					this.$moment()
						.format('YYYY-MM-DD HH:mm:ss')],
				select: this.selectData,
				disciplineList: [],
				identifyList: [
					{ id: -1, name: '全部身份'},
					{ id: 1, name: '医生'},
					{ id: 4, name: '医学生'},
					{ id: 2, name: '企业人员'}
					// { id: 3, name: '制定者'}
                ],
				clientType: [
					{ id: '', name: '全部' },
					{ id: 1, name: '安卓' },
					{ id: 2, name: 'IOS' },
					{ id: 4, name: 'H5' }
				],
				// APP推送
				isOpenAppPushList: [
					{ id: null, name: '全部'},
					{ id: 1, name: '是'},
					{ id: 0, name: '否'}
				],
				// 微信绑定
				isBindWechatList: [
					{ id: null, name: '全部'},
					{ id: 1, name: '是'},
					{ id: 0, name: '否'}
				],
				// 认证类型
				authType: [
          			{ value: -1, label: '全部'},
          			{ 
            			value: 'doctor', 
            			label: '医生', 
            			children: [
              				{ value: 0, label: '权威认证'},
              				{ value: 1, label: '普通认证'},
            			]
          			},
          			{ 
            			value: 'student', 
            			label: '医学生', 
            			children: [
              				{ value: 2, label: '医学生认证'},
              				{ value: 3, label: '实习生认证'},
            			]
          			}
        		],
				// 是否首次认证
				firstAuth: [
					{ value: -1, label: '全部'},
					{ value: 1, label: '是'},
					{ value: 0, label: '否'},
				],
				// 是否审核
				auditList: [
					{ value: -1, label: '全部'},
					{ value: 1, label: '已审核'},
					{ value: 0, label: '待审核'}
				],
				selectVal: {
					content: { key: 0, val: '' },
					timeType: 0,
					type: -1,
					auditingTypeSelect: '',
					departmentsSelect: '',
					jobTitleSelect: '',
					sourceSelect: '',
					province: '',
					city: '',
					hospital: '',
					checkList: [0,1,2,3,4],
					clientType: '',
					sourceNameKey: '',
					orderBy: '',
					authType: -1, // 认证类型
					firstAuth: -1, // 是否首次认证
					isTeacher: '',
					audit: -1, // 是否审核
					disciplineId: null,
					isOpenAppPush: null, // APP推送
					isBindWechat: null // 微信绑定
				},
			}
		},
		props: {
			selectData: {
				type: Object,
				require: true
			}
		},
		mounted() {
			this.getSelectList()
			this.getProvinceList()
			this.getSubjectList()
		},
		methods: {
			// 筛选项静态内容获取
			getSelectList() {
				commonApi.getSelect().then((res) => {
					if(res.Success){
						this.select.auditingTypeSelect === -1
						?res.Data.auditingTypeSelect = -1
						:res.Data.auditingTypeSelect.unshift({id:'',name:'全部审核方式'})
						res.Data.departmentsSelect.unshift({id:'',name:'全部科室'})
						res.Data.jobTitleSelect.unshift({id:'',name:'全部职称'})
						res.Data.sourceSelect.unshift({id:'',name:'全部来源'})
						this.select = {...this.select,...res.Data}
						this.getdepartmentData()
					}else{
						this.$message.error(res.Msg)
					}
				})
			},
			//获取省列表
			getProvinceList() {
				if(this.select.province === -1){return}
				commonApi.getProvince().then(res => {
					if(res.Success){
						res.Data.unshift({code:'',name:'全部省', isopen: true})
						this.select.province = res.Data
					}else{
						this.$message.error(res.Msg)
					}
				})
			},
			// 省改变
			provinceChange(val) {
				// 清空市区，医院
				this.selectVal.city = ''
				this.selectVal.hospital = ''
				// 重置市区，医院列表
				if(val !== ''){
					commonApi.getCityOrArea(this.selectVal.province).then(res => {
						if(res.Success){
                        	res.Data.unshift({code:'',name:'全部城市', isopen: true})
							this.select.city = res.Data
							this.select.hospital = [{id: '', hospitalname: '全部医院'}]
						}else{
							this.select.city = []
							this.$message.error(res.Msg)
						}
					})
				}else{
					this.select.city = [{code: '', name: '全部城市', isopen: true}]
				}
				if(this.select.hospital == -1){ return }
			},
			// 市区改变
			cityChange(val) {
				if(this.select.hospital == -1){ return }
				// 清空医院
				this.selectVal.hospital = ''
				// 重置医院列表
				if(val !== ''){
					var data = {
						code: val
					}
					commonApi.getHospital(data).then(res => {
						if(res.Success){
                        	res.Data.dataList.unshift({id: '', hospitalname: '全部医院'})
							this.select.hospital = res.Data.dataList
						}else{
							this.select.hospital = []
							this.$message.error(res.Msg)
						}
					})
				}else{
					this.select.hospital = [{id: '', hospitalname: '全部医院'}]
				}
			},
			//获取科室
			getdepartmentData() {
				commonApi.getdepartmentData().then((res) => {
					if (res.Success) {
						let newArr = res.Data || []
						newArr.unshift({
							id: '',
							name: '全部科室'
						})
						this.select.departmentsSelect = newArr
					} else {
						this.$message.error(res.Msg)
					}
				})
			},
			// 获取学科
			getSubjectList() {
				if(!this.select.disciplineList) { return }
				subjectApi.getList().then(res => {
					if(res.Success) {
						this.disciplineList = [{
							id: null,
							name: '全部学科'
						}].concat(res.Data.result || [])
					} else {
						this.$message.error(res.Msg)
					}
				})
			},
			
			// 重置筛选
			resetSelect() {
				this.selectVal = {
					content: {
						key: 0,
						val: ''
					},
					timeType: 0,
					auditingTypeSelect: '',
					departmentsSelect: '',
					jobTitleSelect: '',
					sourceSelect: '',
					province: '',
					city: '',
					hospital: '',
					clientType: '',
					sourceNameKey: '',
					checkList: [0,1,2,3,4],
					orderBy: '',
					type: -1,
					authType: -1,
					firstAuth: -1,
					isTeacher: '',
					audit: -1,
					disciplineId: null
				}
				this.$refs.datetime.init()
			},
			selectValFomtter() {
				this.selectVal.datetime = this.$refs.datetime.getTime
				return this.selectVal
			},
			// 认证类型更改
			authTypeChange(val) {
				this.selectVal.authType = val
			}
		}
	};
</script>

<style type="text/less" lang="less" scoped>
	.box-card{
		padding: 15px 0;
	}
	.select_span{
		text-align: right;
		padding-right: 15px;
		span{
			font-size: 14px;
		}
	}
	.check_group{
		display: inline-block;
	}
	.table_list{
		margin: 20px 0;
	}
	.pagination{
		float: right;
	}
	.auth_state{
		padding: 1px 5px;
		color: #fff;
		font-size: 12px;
		background: #909399;
	}
	.normalAuth{
		background: #409EFF;
	}
	.specialAuth{
		background: #67C23A;
	}
  	.select_row>.el-col {
  		position: relative;
  		padding-left: 0!important;
  		padding-right: 0!important;
  		margin-left: 20px;
  		margin-right: 20px;
  		.el-col-7{
	  		padding-left: 0;
	  		padding-right: 0;
	  	}
  	}
  	.searchPart>.el-row{
  		margin-bottom: 10px;
  	}
</style>
<style type="text/less" lang="less">
	.input-with-select .el-input-group__prepend {
	    background-color: #fff;
	}
</style>


// WEBPACK FOOTER //
// src/views/userManage/components/searchPart.vue